import React from 'react';

import { Card } from '@buildoutinc/blueprint-react/ui/Card';
import { Checkbox } from '@buildoutinc/blueprint-react/ui/Checkbox';
import { Label } from '@buildoutinc/blueprint-react/ui/Label';

import CompanyOfficeSelect from 'bundles/company/permissions/shared/company_office_select';
import OfficeBadge from 'bundles/company/permissions/shared/office_badge';

import type { OfficeAdminData } from 'components/users/types';

interface Props {
  data: OfficeAdminData;
  checked: boolean;
  selectedOfficeIds: number[];
  onToggle: (value: boolean) => void;
  onChangeOffices: (ids: number[]) => void;
}

export default function OfficeAdminCard({ data, checked, selectedOfficeIds, onToggle, onChangeOffices }: Props) {
  const labelById = new Map(data.officeOptions.map(option => [option.value, option.label]));

  const availableOptions = data.officeOptions
    .filter(option => !selectedOfficeIds.includes(option.value))
    .map(option => ({ value: String(option.value), label: option.label }));

  return (
    <div className="col-sm-6">
      <Card className="h-100">
        <Card.Body>
          <div className="d-flex align-items-start gap-2">
            <Checkbox
              checked={checked}
              className="mt-1 flex-shrink-0"
              disabled={data.disabled}
              id="user_office_admin"
              onCheckedChange={value => onToggle(value === true)}
            />
            <Label className="clickable fw-normal" htmlFor="user_office_admin">
              <span className="d-block">{data.label}</span>
              <span className="d-block fw-light small mt-1">{data.description}</span>
            </Label>
          </div>

          {checked && (
            <div className="ms-5 mt-3 d-flex gap-2 flex-wrap">
              {selectedOfficeIds.map(officeId => (
                <OfficeBadge
                  key={officeId}
                  officeName={labelById.get(officeId) ?? ''}
                  onClick={() => onChangeOffices(selectedOfficeIds.filter(id => id !== officeId))}
                />
              ))}
              <div className="flex-grow-1">
                <CompanyOfficeSelect
                  companyOfficeOptions={availableOptions}
                  placeholder=""
                  onChange={({ value }) => onChangeOffices([...selectedOfficeIds, parseInt(value, 10)])}
                />
              </div>
            </div>
          )}
        </Card.Body>
      </Card>
    </div>
  );
}
